/* eslint-disable prettier/prettier */
import { colors } from 'lib/colors'

export const handleBackgroudColor = (
  deal: boolean | undefined,
  result: string | undefined,
  win: boolean | undefined,
): string => {
  return deal
    ? result === 'TIE'
      ? colors.tieColor
      : win
      ? colors.cardGreen
      : colors.secondaryText
    : '#e7e2de'
}
